import React from "react";
import { cn } from "./utils";
import { iconVariants, type IIconInterface } from "./icon.interface";

export const SvgIcon: React.FC<
  IIconInterface & {
    viewBox: string;
    children: React.ReactNode;
  }
> = ({
  title,
  height,
  color,
  variant,
  size,
  width,
  testId,
  viewBox,
  children,
  className,
}): JSX.Element => {
  const fill = { fill: variant === "filled" ? "currentColor" : "none" };
  return (
    <svg
      className={cn(iconVariants({ color, size, variant, className }))}
      data-testid={testId}
      height={height}
      stroke="currentColor"
      viewBox={viewBox}
      width={width}
      {...fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      {children}
    </svg>
  );
};
